export const uk = {
    cancel: 'Отмена',
    'no-creatives': 'Нет архивных креативов',
    view: 'Посмотреть'
};
